import second_bg from "@Assets/backgrounds/second-bg.png";
import hero from "@Assets/backgrounds/hero.jpeg";

export const contents = [
  {
    index: 0,
    subtitle:
      "The Human Salivary Proteome (HSP) is a collaborative, community-based Web portal to more than 1000 unique human saliva proteins identified by high-throughput proteomic technologies. The HSP is developed for the research community and the public to harness the knowledge in the data and to further enhance the value of the proteome.",
    subtitle1:
      "The chord diagram provides salivary protein catalog with each arc in the diagram represents the set of proteins found in the connected tissue or sample types. Click on Chord image to go to salivary protein catalog page that provides the interactive chord diagram and salivary protein search capability.",
    img: hero,
  },
  {
    index: 1,
    title: "Clinical Application: Sars-CoV-2 in Saliva",
    subtitle:
      "Via shotgun proteomics, we have mapped salivary proteomes of COVID-19 and healthy subjects. We aim to understand further the molecular cues of the virus on the context of health and disease.",
    img: second_bg,
  },
];
